import type {SVGProps} from 'react'

const SvgConfigurator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={48}
    height={48}
    fill={'none'}
    viewBox={'0 0 48 48'}
    {...props}
  >
    <path
      stroke={'currentColor'}
      strokeWidth={1.2}
      d={'m32.32 15.98 1.28-1.28h1.92M15.68 15.98 14.4 14.7h-1.92M24 37.65c-9.94 0-18-3.223-18-7.2 0-.955.465-1.866 1.309-2.7M29.4 37.32c7.303-.917 12.6-3.646 12.6-6.87 0-.955-.464-1.866-1.308-2.7'}
    />
    <path
      stroke={'currentColor'}
      strokeWidth={1.2}
      d={'m20.5 41.15 3.5-3.5-3.5-3.5M16.684 13.424a3.73 3.73 0 0 1 3.644-2.924h7.344a3.73 3.73 0 0 1 3.644 2.924L32 16.5H16zM13.5 20a3.5 3.5 0 0 1 3.5-3.5h14a3.5 3.5 0 0 1 3.5 3.5v5a1 1 0 0 1-1 1H31a1 1 0 0 1-1-1v-2H18v2a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1z'}
    />
  </svg>
)
export default SvgConfigurator
